/**
 * Generated by orval v8.19.0 🍺
 * Do not edit manually.
 * Catalog Api
 * REST api
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DietDietWrite,
  DietJsonldDietAdminRead,
  DietJsonldDietRead,
  DietJsonldDietWrite,
  GetCollectionFrontend200,
  GetCollectionFrontendParams,
  GetDietBySlug200,
  GetDietBySlugParams
} from './schemas';

import { apiCatalog } from '../../apiCatalog';



// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type diet_postResponse201 = {
  data: DietJsonldDietAdminRead
  status: 201
}

export type diet_postResponse400 = {
  data: void
  status: 400
}

export type diet_postResponse422 = {
  data: void
  status: 422
}

export type diet_postResponseSuccess = (diet_postResponse201) & {
  headers: Headers;
};
export type diet_postResponseError = (diet_postResponse400 | diet_postResponse422) & {
  headers: Headers;
};

export type diet_postResponse = (diet_postResponseSuccess | diet_postResponseError)

export const getDietPostUrl = () => {




  return `/api/diet`
}

/**
 * Creates a Diet resource.
 * @summary Creates a Diet resource.
 */
export const diet_post = async (dietPostBody: NonReadonly<DietJsonldDietWrite | DietDietWrite>, options?: RequestInit): Promise<diet_postResponse> => {

  return apiCatalog<diet_postResponse>(getDietPostUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: JSON.stringify(dietPostBody)
  }
);}





export const getDietPostMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof diet_post>>, TError,{data: NonReadonly<DietJsonldDietWrite | DietDietWrite>}, TContext>, request?: SecondParameter<typeof apiCatalog>}
): UseMutationOptions<Awaited<ReturnType<typeof diet_post>>, TError,{data: NonReadonly<DietJsonldDietWrite | DietDietWrite>}, TContext> => {

const mutationKey = ['dietPost'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof diet_post>>, {data: NonReadonly<DietJsonldDietWrite | DietDietWrite>}> = (props) => {
          const {data} = props ?? {};

          return  diet_post(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DietPostMutationResult = NonNullable<Awaited<ReturnType<typeof diet_post>>>
    export type DietPostMutationBody = NonReadonly<DietJsonldDietWrite | DietDietWrite>
    export type DietPostMutationError = void

    /**
 * @summary Creates a Diet resource.
 */
export const useDietPost = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof diet_post>>, TError,{data: NonReadonly<DietJsonldDietWrite | DietDietWrite>}, TContext>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof diet_post>>,
        TError,
        {data: NonReadonly<DietJsonldDietWrite | DietDietWrite>},
        TContext
      > => {
      return useMutation(getDietPostMutationOptions(options), queryClient);
    }
    export type diet_patchResponse200 = {
  data: DietJsonldDietAdminRead
  status: 200
}

export type diet_patchResponse400 = {
  data: void
  status: 400
}

export type diet_patchResponse404 = {
  data: void
  status: 404
}

export type diet_patchResponse422 = {
  data: void
  status: 422
}

export type diet_patchResponseSuccess = (diet_patchResponse200) & {
  headers: Headers;
};
export type diet_patchResponseError = (diet_patchResponse400 | diet_patchResponse404 | diet_patchResponse422) & {
  headers: Headers;
};

export type diet_patchResponse = (diet_patchResponseSuccess | diet_patchResponseError)

export const getDietPatchUrl = (id: string,) => {




  return `/api/diet/${id}`
}

/**
 * Updates the Diet resource.
 * @summary Updates the Diet resource.
 */
export const diet_patch = async (id: string,
    dietDietWrite: NonReadonly<DietDietWrite>, options?: RequestInit): Promise<diet_patchResponse> => {

  return apiCatalog<diet_patchResponse>(getDietPatchUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/merge-patch+json', ...options?.headers },
    body: JSON.stringify(dietDietWrite)
  }
);}





export const getDietPatchMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof diet_patch>>, TError,{id: string;data: NonReadonly<DietDietWrite>}, TContext>, request?: SecondParameter<typeof apiCatalog>}
): UseMutationOptions<Awaited<ReturnType<typeof diet_patch>>, TError,{id: string;data: NonReadonly<DietDietWrite>}, TContext> => {

const mutationKey = ['dietPatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof diet_patch>>, {id: string;data: NonReadonly<DietDietWrite>}> = (props) => {
          const {id,data} = props ?? {};

          return  diet_patch(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DietPatchMutationResult = NonNullable<Awaited<ReturnType<typeof diet_patch>>>
    export type DietPatchMutationBody = NonReadonly<DietDietWrite>
    export type DietPatchMutationError = void

    /**
 * @summary Updates the Diet resource.
 */
export const useDietPatch = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof diet_patch>>, TError,{id: string;data: NonReadonly<DietDietWrite>}, TContext>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof diet_patch>>,
        TError,
        {id: string;data: NonReadonly<DietDietWrite>},
        TContext
      > => {
      return useMutation(getDietPatchMutationOptions(options), queryClient);
    }
    export type get_collection_frontendResponse200 = {
  data: GetCollectionFrontend200
  status: 200
}

export type get_collection_frontendResponseSuccess = (get_collection_frontendResponse200) & {
  headers: Headers;
};
;

export type get_collection_frontendResponse = (get_collection_frontendResponseSuccess)

export const getGetCollectionFrontendUrl = (params?: GetCollectionFrontendParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["name[]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/diets?${stringifiedParams}` : `/api/diets`
}

/**
 * Retrieves the collection of Diet resources.
 * @summary Retrieves the collection of Diet resources.
 */
export const get_collection_frontend = async (params?: GetCollectionFrontendParams, options?: RequestInit): Promise<get_collection_frontendResponse> => {

  return apiCatalog<get_collection_frontendResponse>(getGetCollectionFrontendUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCollectionFrontendQueryKey = (params?: GetCollectionFrontendParams,) => {
    return [
    `/api/diets`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCollectionFrontendQueryOptions = <TData = Awaited<ReturnType<typeof get_collection_frontend>>, TError = unknown>(params?: GetCollectionFrontendParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_collection_frontend>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCollectionFrontendQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof get_collection_frontend>>> = ({ signal }) => get_collection_frontend(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof get_collection_frontend>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCollectionFrontendQueryResult = NonNullable<Awaited<ReturnType<typeof get_collection_frontend>>>
export type GetCollectionFrontendQueryError = unknown


export function useGetCollectionFrontend<TData = Awaited<ReturnType<typeof get_collection_frontend>>, TError = unknown>(
 params: undefined |  GetCollectionFrontendParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_collection_frontend>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof get_collection_frontend>>,
          TError,
          Awaited<ReturnType<typeof get_collection_frontend>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCollectionFrontend<TData = Awaited<ReturnType<typeof get_collection_frontend>>, TError = unknown>(
 params?: GetCollectionFrontendParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_collection_frontend>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof get_collection_frontend>>,
          TError,
          Awaited<ReturnType<typeof get_collection_frontend>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCollectionFrontend<TData = Awaited<ReturnType<typeof get_collection_frontend>>, TError = unknown>(
 params?: GetCollectionFrontendParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_collection_frontend>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the collection of Diet resources.
 */

export function useGetCollectionFrontend<TData = Awaited<ReturnType<typeof get_collection_frontend>>, TError = unknown>(
 params?: GetCollectionFrontendParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_collection_frontend>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCollectionFrontendQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type get_diet_by_slugResponse200 = {
  data: GetDietBySlug200
  status: 200
}

export type get_diet_by_slugResponseSuccess = (get_diet_by_slugResponse200) & {
  headers: Headers;
};
;

export type get_diet_by_slugResponse = (get_diet_by_slugResponseSuccess)

export const getGetDietBySlugUrl = (slug: string,
    params?: GetDietBySlugParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["name[]"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/diets-slug/${slug}?${stringifiedParams}` : `/api/diets-slug/${slug}`
}

/**
 * Retrieves the collection of Diet resources.
 * @summary Retrieves the collection of Diet resources.
 */
export const get_diet_by_slug = async (slug: string,
    params?: GetDietBySlugParams, options?: RequestInit): Promise<get_diet_by_slugResponse> => {

  return apiCatalog<get_diet_by_slugResponse>(getGetDietBySlugUrl(slug,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDietBySlugQueryKey = (slug: string,
    params?: GetDietBySlugParams,) => {
    return [
    `/api/diets-slug/${slug}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDietBySlugQueryOptions = <TData = Awaited<ReturnType<typeof get_diet_by_slug>>, TError = unknown>(slug: string,
    params?: GetDietBySlugParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_diet_by_slug>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDietBySlugQueryKey(slug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof get_diet_by_slug>>> = ({ signal }) => get_diet_by_slug(slug,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: slug !== null && slug !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof get_diet_by_slug>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDietBySlugQueryResult = NonNullable<Awaited<ReturnType<typeof get_diet_by_slug>>>
export type GetDietBySlugQueryError = unknown


export function useGetDietBySlug<TData = Awaited<ReturnType<typeof get_diet_by_slug>>, TError = unknown>(
 slug: string,
    params: undefined |  GetDietBySlugParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_diet_by_slug>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof get_diet_by_slug>>,
          TError,
          Awaited<ReturnType<typeof get_diet_by_slug>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDietBySlug<TData = Awaited<ReturnType<typeof get_diet_by_slug>>, TError = unknown>(
 slug: string,
    params?: GetDietBySlugParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_diet_by_slug>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof get_diet_by_slug>>,
          TError,
          Awaited<ReturnType<typeof get_diet_by_slug>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDietBySlug<TData = Awaited<ReturnType<typeof get_diet_by_slug>>, TError = unknown>(
 slug: string,
    params?: GetDietBySlugParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_diet_by_slug>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves the collection of Diet resources.
 */

export function useGetDietBySlug<TData = Awaited<ReturnType<typeof get_diet_by_slug>>, TError = unknown>(
 slug: string,
    params?: GetDietBySlugParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_diet_by_slug>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDietBySlugQueryOptions(slug,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type get_frontendResponse200 = {
  data: DietJsonldDietRead
  status: 200
}

export type get_frontendResponse404 = {
  data: void
  status: 404
}

export type get_frontendResponseSuccess = (get_frontendResponse200) & {
  headers: Headers;
};
export type get_frontendResponseError = (get_frontendResponse404) & {
  headers: Headers;
};

export type get_frontendResponse = (get_frontendResponseSuccess | get_frontendResponseError)

export const getGetFrontendUrl = (id: string,) => {




  return `/api/diets/${id}`
}

/**
 * Retrieves a Diet resource.
 * @summary Retrieves a Diet resource.
 */
export const get_frontend = async (id: string, options?: RequestInit): Promise<get_frontendResponse> => {

  return apiCatalog<get_frontendResponse>(getGetFrontendUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetFrontendQueryKey = (id: string,) => {
    return [
    `/api/diets/${id}`
    ] as const;
    }


export const getGetFrontendQueryOptions = <TData = Awaited<ReturnType<typeof get_frontend>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_frontend>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFrontendQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof get_frontend>>> = ({ signal }) => get_frontend(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof get_frontend>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFrontendQueryResult = NonNullable<Awaited<ReturnType<typeof get_frontend>>>
export type GetFrontendQueryError = void


export function useGetFrontend<TData = Awaited<ReturnType<typeof get_frontend>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_frontend>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof get_frontend>>,
          TError,
          Awaited<ReturnType<typeof get_frontend>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFrontend<TData = Awaited<ReturnType<typeof get_frontend>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_frontend>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof get_frontend>>,
          TError,
          Awaited<ReturnType<typeof get_frontend>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFrontend<TData = Awaited<ReturnType<typeof get_frontend>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_frontend>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Retrieves a Diet resource.
 */

export function useGetFrontend<TData = Awaited<ReturnType<typeof get_frontend>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof get_frontend>>, TError, TData>>, request?: SecondParameter<typeof apiCatalog>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetFrontendQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






